var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.983 29.776a1.377 1.377 0 0 1 0-1.953l26.933-26.76a1.377 1.377 0 0 1 1.94 1.953L2.925 29.776a1.377 1.377 0 0 1-1.941 0Z",
    fill: "#53565A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.983 1.062a1.377 1.377 0 0 1 1.941 0l26.933 26.76a1.377 1.377 0 1 1-1.941 1.954L.983 3.016a1.377 1.377 0 0 1 0-1.954Z",
    fill: "#53565A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.b88efeecc1d36e9e23f3618eb045e146.svg";
export { ForwardRef as ReactComponent };